<template>
  <div>
    <label v-if="label && !required">
      {{ label }}
    </label>
    <label-required-field v-if="label && required" :label="label" />
    <b-textarea
      :disabled="running || disabled"
      :max-rows="maxRows"
      :placeholder="placeholder"
      :required="required"
      :rows="rows"
      :value="value"
      @input="evTextareaOnInput"
      @keyup="evTextareaOnKeyUp"
    />
    <errors-messages v-if="use_service" :errors="errors" />
    <div class="row" v-if="use_service && !disabled">
      <div class="col-xl-6">
        <b-checkbox
          :disabled="running"
          v-model="append"
          style="user-select: none"
          switch
        >
          {{ append ? "Adicionar" : "Substituir" }}
        </b-checkbox>
      </div>
      <div class="col-xl-6" v-show="recording">
        <div class="d-flex justify-content-end align-items-center">
          <b-spinner
            type="border"
            class="mr-2"
            style="width: 30px; height: 30px"
            v-show="recording"
            :variant="running ? 'primary' : 'secondary'"
          />
          <v-btn v-show="recording" class="btn-cancel ml-2 mr-2" @click="abort">
            CANCELAR
          </v-btn>
          <v-btn
            v-show="recording"
            class="btn-check-record ml-2 mr-2"
            @click="stop"
          >
            <i class="fas fa-microphone text-eighteen mr-2"></i> SALVAR
          </v-btn>
        </div>
      </div>
      <div class="col-xl-6 text-right" v-show="!recording">
        <v-btn
          v-show="!recording && String(value).length > 0"
          class="btn-cancel"
          @click="evOnBtnClearClick"
        >
          LIMPAR
        </v-btn>
        <v-btn
          v-show="!recording"
          class="btn-record ml-2"
          @click="start"
          style="min-width: 30px !important"
        >
          <i class="fas fa-microphone text-eighteen"></i>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "./ErrorsMessages";
import LabelRequiredField from "./LabelRequiredField.vue";

export default {
  name: "ChromeSpeechToTextTextarea",

  components: { ErrorsMessages, LabelRequiredField },

  props: {
    disabled: { type: Boolean, default: false },
    label: { type: String, default: undefined },
    maxRows: { type: [String, Number], default: undefined },
    placeholder: { type: String, default: undefined },
    required: { type: Boolean, default: false },
    rows: { type: [String, Number], default: 3 },
    value: { type: String, default: "" },
  },

  data() {
    return {
      errors: [],
      loading: false,

      use_service: true,
      recording: false,
      running: false,

      append: true,
      prefix: "",

      /** @type {SpeechRecognition} */
      service: undefined,
    };
  },

  created() {
    this.setup().then();
  },

  methods: {
    async setup() {
      try {
        let SpeechRecognition =
          window.SpeechRecognition || window.webkitSpeechRecognition;
        this.service = new SpeechRecognition();

        this.service.continuous = true;
        this.service.lang = "pt-BR";
        this.service.interimResults = false;
        this.service.maxAlternatives = 1;

        this.service.addEventListener("start", this.evServiceOnStart);
        this.service.addEventListener("end", this.evServiceOnEnd);

        this.service.addEventListener("audiostart", this.evServiceOnAudioStart);
        this.service.addEventListener("audioend", this.evServiceOnAudioEnd);

        this.service.addEventListener("result", this.evServiceOnResult);

        this.service.addEventListener("error", this.evServiceOnError);
      } catch (error) {
        if (error.name == "TypeError") this.use_service = false;

        this.errors = [];
        let message =
          {
            TypeError: "Serviço não suportado",
          }[error.name] || "Ocorreu um erro";
        this.errors.push(message);
      }
    },

    async start() {
      this.service.start();
    },
    async stop() {
      this.service.stop();
    },
    async abort() {
      this.service.abort();
    },

    async evServiceOnStart() {
      this.prefix = this.value;
      this.running = true;
    },
    async evServiceOnEnd() {
      this.prefix = "";
      this.running = false;
    },

    async evServiceOnAudioStart() {
      this.recording = true;
    },
    async evServiceOnAudioEnd() {
      this.recording = false;
    },

    async evServiceOnResult(ev) {
      /**@type {SpeechRecognitionResult} */
      let results = ev.results;
      let output = "";
      for (let result of results) {
        let str = result[0].transcript + ".";
        let start = str.replace(/([\s]*[a-zA-Z]{1})(.*)/, "$1");
        let end = str.replace(/([\s]*[a-zA-Z]{1})(.*)/, "$2");
        output += start.toUpperCase() + end;
      }

      if (this.append && this.prefix) output = this.prefix + " " + output;
      output = output.trim();
      this.$emit("input", output);
    },

    async evServiceOnError(ev) {
      let ignore = {
        aborted: true,
        "no-speech": true,
      }[ev.error];
      if (ignore) return;

      this.errors = [];
      let message =
        {
          "not-allowed": "Uso do microfone bloqueado",
          aborted: "Cancelado",
        }[ev.error] || "Ocorreu um erro";
      this.errors.push(message);
    },

    async evTextareaOnInput(val) {
      this.$emit("input", val);
    },

    async evTextareaOnKeyUp(val) {
      this.$emit("keyup", val);
    },

    async evOnBtnClearClick() {
      this.$emit("input", "");
    },
  },
};
</script>

<style></style>
